import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { ColorPicker } from "primereact/colorpicker";
import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import { DatasetChartProps } from "../../interfaces";

interface IBarChartIdentifiersEditorProps {
    currentConfig: DatasetChartProps;
    setCurrentConfig: React.Dispatch<React.SetStateAction<DatasetChartProps>>;
}

const BarChartIdentifiersEditor = ({
  currentConfig,
  setCurrentConfig,
}: IBarChartIdentifiersEditorProps) => {
  const colorEditor = (options: any) => {
    return (
      <div className="p-inputgroup">
        <InputText
          value={options.value}
          onChange={e => options.editorCallback(e.target.value)}
          style={{ width: "100%" }}
        />
        <ColorPicker
          className="p-inputgroup-addon p-0"
          value={options.value}
          onChange={e => options.editorCallback(`#${  e.value}`)}
          style={{ width: "50%" }}
        />
      </div>
    );
  };

  const colorBodyTemplate = (rowData: any, field: string) => {
    return (
      <div className="flex justify-content-center">
        {field === "color" ? (
          <div
            style={{
              backgroundColor: rowData.color,
              width: "25px",
              height: "25px",
              border: "1px solid black",
            }}
          />
        ) : (
          <div
            style={{
              backgroundColor: rowData.bgColor,
              width: "25px",
              height: "25px",
              border: "1px solid black",
            }}
          />
        )}
      </div>
    );
  };

  const onRowEditComplete = (e: any) => {
      const datasetsToUpdate = [...currentConfig.datasets!];
      const { newData } = e;
      setCurrentConfig({
        ...currentConfig,
        datasets: datasetsToUpdate.map((dataset) => {
          if (dataset.identifier === newData.identifier) {
            return { ...dataset, ...newData };
          } 
            return dataset;
          
        }),
      })
  };

  const titleBodyTemplate = (rowData: any) => {
    return <DatasetTitle identifier={rowData.identifier} />;
  };

  const textEditor = (options: any) => {
    return (
      <InputText
        value={options.value || ""}
        onChange={e => options.editorCallback(e.target.value)}
        style={{ width: "100%" }}
      />
    );
  };

  const overriddenTitleBodyTemplate = (rowData: any) => {
    return <div>{rowData.overriddenTitle}</div>;
  };

  return (
    <DataTable value={currentConfig.datasets} editMode="row" onRowEditComplete={onRowEditComplete}>
      <Column field="identifier" header="Identifier" body={titleBodyTemplate} />
      <Column
        field="overriddenTitle"
        header="Overriden Title"
        editor={textEditor}
        body={overriddenTitleBodyTemplate}
      />
      <Column
        className="p-0 w-9rem"
        field="color"
        header="Color"
        align="center"
        editor={colorEditor}
        body={rowData => colorBodyTemplate(rowData, "color")}
      />      
      <Column rowEditor />
    </DataTable>
  );
};

export default BarChartIdentifiersEditor;
